import React, { createContext, useContext } from 'react';

// Create context for header updates
const HeaderContext = createContext({
  updateCart: () => {},
  updatePrintCash: () => {}
});

// Custom hook to use header context
export const useHeader = () => {
  const context = useContext(HeaderContext);
  if (!context) {
    console.warn('useHeader must be used within HeaderProvider');
    return { updateCart: () => {}, updatePrintCash: () => {} };
  }
  return context;
};

export default HeaderContext;
